import * as Sentry from '@sentry/browser';

export default function initSentry() {
    Sentry.init({
        dsn: process.env.GLITCHTIP_SENTRY_DSN,
        ignoreErrors: [
            RegExp('^Failed to execute \'setStart\' on \'Range\': The offset', 'i'), // Most likely due to the wysiwyg implementation (https://github.com/summernote/summernote/issues/4392)
            RegExp('^Non-Error promise rejection captured with value: Object Not Found Matching Id:', 'i'),
            // Probably caused when a rejection is raised with a non-error object,
            // from which we cannot extract much information.
            // Most likely these are caused by safe links feature of Outlook: https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-1233146122
        ],
        autoSessionTracking: false,
        integrations: [
            new Sentry.BrowserTracing({
                tracePropagationTargets: [process.env.GLITCHTIP_URL_REGEX],
            }),
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
    });
}
